import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

import { Button } from "@/components/ui/button";

/**
 * Section CTA secondaire (S7-5, GAP-3 ; copy V1 refondue S16-3).
 *
 * Bouton dupliqué (le visiteur a parcouru la page, on lui redonne la main
 * sans le forcer à remonter). Le consentement RGPD est recueilli par la modale
 * qu'il verra sur `/simulations/new`, et la politique reste liée depuis le
 * header/footer.
 *
 * Libellé du CTA aligné sur le vocabulaire de nav figé S16-2
 * (« Nouvelle simulation »).
 */
export function LandingCta(): JSX.Element {
  return (
    <section
      aria-labelledby="cta-title"
      className="bg-white py-16 sm:py-20"
    >
      <div className="mx-auto max-w-4xl rounded-2xl border border-amber-200 bg-gradient-to-br from-amber-50 to-white px-6 py-12 text-center shadow-sm sm:px-12">
        <h2
          id="cta-title"
          className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl"
        >
          Prêt à dimensionner votre installation ?
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-base text-slate-700">
          Lancez une simulation en quelques minutes, sans inscription. Vos
          données de simulation sont rattachées à une session anonyme et
          conservées le temps de votre activité (voir notre{" "}
          <Link
            to="/politique-confidentialite"
            className="font-medium underline underline-offset-4 hover:no-underline"
          >
            politique de confidentialité
          </Link>
          ).
        </p>
        <div className="mt-8 flex flex-col items-center gap-4">
          <Button asChild size="lg" className="w-full sm:w-auto">
            <Link
              to="/simulations/new"
              className="inline-flex items-center justify-center gap-2"
            >
              Nouvelle simulation
              <ArrowRight className="h-4 w-4" aria-hidden />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
